import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import api from '../api';

Vue.use(Vuex);

import { users } from './user.module';

const baseURL = 'https://staging.api.talentalt.com';

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
    countries: [],
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, token, user) {
      state.status = 'success';
      state.token = token;
      state.user = user;
    },
    request_success(state) {
      state.status = 'success';
    },
    auth_error(state) {
      state.status = 'error';
    },
    logout(state) {
      state.status = '';
      state.token = '';
    },
  },
  actions: {
    signup({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        api({
          url: `${baseURL}/signup`,
          data: user,
          method: 'POST',
        })
          .then((resp) => {
            // const token = resp.data.token;
            // const user = resp.data.user;
            // console.log(resp);
            // localStorage.setItem('token', token);
            // axios.defaults.headers.common['Authorization'] = token
            // commit('auth_success', token, user)
            resolve(resp);
          })
          .catch((err) => {
            // console.log(err);
            commit('auth_error', err);
            localStorage.removeItem('token');
            reject(err);
          });
      });
    },

    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        api({
          url: `${baseURL}/login`,
          data: user,
          method: 'POST',
        })
          .then((resp) => {
            // console.log(resp);
            // const token = resp.data.token
            // const user = resp.data.user
            // localStorage.setItem('token', token)
            // Add the following line:
            // axios.defaults.headers.common['Authorization'] = token
            // commit('auth_success', token, user)
            resolve(resp);
          })
          .catch((err) => {
            commit('auth_error');
            localStorage.removeItem('token');
            reject(err);
          });
      });
    },

    logout({ commit }) {
      return new Promise((resolve, reject) => {
        api({
          url: `${baseURL}/logout`,
          method: 'POST',
        })
          .then((resp) => {
            commit('logout');
            localStorage.removeItem('token');
            delete axios.defaults.headers.common['Authorization'];
            resolve(resp);
          })
          .catch((err) => {
            commit('auth_error');
            reject(err);
          });
      });
    },

    requestToken({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        //expects email field
        api({
          url: `${baseURL}/token`,
          data: user,
          method: 'POST',
        })
          .then((resp) => {
            commit('request_success');
            resolve(resp);
          })
          .catch((err) => {
            commit('auth_error');
            reject(err);
          });
      });
    },

    verifyToken({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        //expects token field
        api({
          url: `${baseURL}/verify`,
          data: user,
          method: 'POST',
        })
          .then((resp) => {
            commit('request_success');
            resolve(resp);
          })
          .catch((err) => {
            commit('auth_error');
            reject(err);
          });
      });
    },

    forgetPassword({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        //expects email field
        api({
          url: `${baseURL}/forget`,
          data: user,
          method: 'POST',
        })
          .then((resp) => {
            commit('request_success');
            resolve(resp);
          })
          .catch((err) => {
            commit('auth_error');
            reject(err);
          });
      });
    },

    resetPassword({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        //expects resetToken and newPassword field
        api({
          url: `${baseURL}/reset`,
          data: user,
          method: 'POST',
        })
          .then((resp) => {
            commit('request_success');
            resolve(resp);
          })
          .catch((err) => {
            commit('auth_error');
            reject(err);
          });
      });
    },

    getCountries({ commit, state }) {
      return new Promise((resolve, reject) => {
        api({
          method: 'GET',
          url:
            'https://salnazi-country-codes-v1.p.rapidapi.com/api.php?apiKey=8923sa7aAS7s&secret=us7uS78sj%3Fapikey%3D8923sa7aAS7s&secret=us7uS78sj',
          headers: {
            'x-rapidapi-host': 'salnazi-country-codes-v1.p.rapidapi.com',
            'x-rapidapi-key':
              '6ca124e468msh22c5cc821adbce1p14a23ejsn2364b404d00d',
          },
        })
          .then((response) => {
            state.countries = response.data;
            resolve(response);
            // console.log(response.data);
          })
          .catch((err) => {
            commit('auth_error');
            reject(err);
          });
      });
    },
  },
  modules: {
    users,
  },
});
